import fetch from '@/plugin/axios'

// 新增列表
export function getAdd (query) {
  return fetch({
    url: '/api/common/custom-page/add',
    method: 'Post',
    data: query
  })
}

// 查询列表
export function getListcu (query) {
  return fetch({
    url: '/api/common/custom-page/list',
    method: 'Post',
    data: query
  })
}

// 装修页信息
export function getinfo (id) {
  return fetch({
    url: `/api/common/custom-page/info/${id}`,
    method: 'GET'
  })
}

// 修改装修页
export function getUpdate (id, query) {
  return fetch({
    url: `/api/common/custom-page/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 状态修改
export function getStatus (id, query) {
  return fetch({
    url: `/api/common/custom-page/status/${id}`,
    method: 'get',
    params: query
  })
}
